module.exports = __webpack_public_path__ + "8f81f3d7e3cf04e57d9a4b1e742be838.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/blue/enlexp.png
// module id = 2404
// module chunks = 0